import { diContainer, serviceNames } from '../diContainer/diContainer';
import { CART_NOTIFICATIONS, ADDRESS_NOTIFICATIONS, SHIPPING_NOTIFICATIONS, NOTIFICATION_GROUP, NOTIFICATION_TYPE } from '../constants/Notifications';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';

class SetNotificationsFromTransactionUseCase {
  private notificationsCollection: NotificationsCollection;

  constructor() {
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
  }

  public execute = (): void => {
    if (this.notificationsCollection.offerRemoved) {
      this.notificationsCollection.addNotification({
        group: NOTIFICATION_GROUP.SHIPPING,
        key: CART_NOTIFICATIONS.OFFER_REMOVED,
        type: NOTIFICATION_TYPE.WARNING,
      });
      this.notificationsCollection.addNotification({
        group: NOTIFICATION_GROUP.PAYMENT,
        key: ADDRESS_NOTIFICATIONS.OFFER_REPLACED_SKUS_RESTRICTED,
        type: NOTIFICATION_TYPE.WARNING,
      });
    }
    if (this.notificationsCollection.hasNotification(
      ADDRESS_NOTIFICATIONS.OFFER_REPLACED_SKUS_RESTRICTED,
    )) {
      this.notificationsCollection.addNotification({
        group: NOTIFICATION_GROUP.SHIPPING,
        key: ADDRESS_NOTIFICATIONS.OFFER_REPLACED_SKUS_RESTRICTED,
        type: NOTIFICATION_TYPE.WARNING,
      });
    }

    const productHazmatRestrictionNotification = this.notificationsCollection.notifications
      .find(notification => notification.key === SHIPPING_NOTIFICATIONS.PRODUCT_HAZMAT_RESTRICTION);
    if (productHazmatRestrictionNotification) {
      this.notificationsCollection.addNotification({
        ...productHazmatRestrictionNotification,
        group: NOTIFICATION_GROUP.SHIPPING,
        type: NOTIFICATION_TYPE.WARNING,
      });
    }
  };
}

export default SetNotificationsFromTransactionUseCase;
